// Seed data for /infrastructure when Firestore has no projects yet.
// Sourced from team page bios (src/pages/team.js) + Fabio's CV (PDF).
// Edit here, redeploy, then once /admin-projects has real rows the
// section will switch to live data automatically.
//
// Project IDs are arbitrary stable strings so the codename hash stays
// stable across deploys.
//
// Two juniors are placeholders ("Junior 1" / "Junior 2") — replace with
// real names once people are onboarded.

const SEED_MEMBERS = [
  { id: "m:fabio",    name: "Fabio",    role: "Lead DevOps Engineer",       seniority: "senior" },
  { id: "m:matias",   name: "Matías",   role: "Senior Cloud Engineer · SRE", seniority: "senior" },
  { id: "m:jeremias", name: "Jeremías", role: "DevOps Engineer · AWS",       seniority: "senior" },
  { id: "m:junior1",  name: "Junior 1", role: "Junior DevOps Engineer",      seniority: "junior" },
  { id: "m:junior2",  name: "Junior 2", role: "Junior DevOps Engineer",      seniority: "junior" },
];

const SEED_PROJECTS = [
  {
    id: "seed-dioscuro-platform",
    company: "Dioscuro",
    industry: "infra",
    status: "active",
    stack: [
      "aws", "eks", "kubernetes", "terraform", "argocd", "github-actions",
      "datadog", "opentelemetry", "ethereum-node", "ipfs", "pulumi",
    ],
    memberIds: ["m:fabio"],
  },
  {
    id: "seed-consensys-infura",
    company: "Consensys Infura (via Endava)",
    industry: "infra",
    status: "active",
    stack: [
      "aws", "eks", "ethereum-node", "ipfs", "argocd", "flux", "terraform",
      "pulumi", "datadog", "opentelemetry", "grafana",
    ],
    memberIds: ["m:fabio"],
  },
  {
    id: "seed-aws-scale-eng",
    company: "Senior AWS scaling engagement",
    industry: "saas",
    status: "active",
    stack: [
      "aws", "ecs", "s3", "elasticache", "grafana", "prometheus", "loki",
      "datadog",
    ],
    memberIds: ["m:matias"],
  },
  {
    id: "seed-cloud-native-pipelines",
    company: "Cloud-native CI/CD",
    industry: "saas",
    status: "active",
    stack: [
      "kubernetes", "docker", "terraform", "ansible", "github-actions",
      "gitlab-ci", "prometheus", "grafana",
    ],
    memberIds: ["m:jeremias"],
  },
  {
    id: "seed-junior-sandbox-1",
    company: "Junior 1 sandbox",
    industry: "other",
    status: "active",
    stack: ["aws", "docker", "github-actions"],
    memberIds: ["m:junior1"],
  },
  {
    id: "seed-junior-sandbox-2",
    company: "Junior 2 sandbox",
    industry: "other",
    status: "active",
    stack: ["gcp", "kubernetes", "helm"],
    memberIds: ["m:junior2"],
  },
];

export { SEED_MEMBERS, SEED_PROJECTS };
